import './App.css';
import { Link } from 'react-router-dom';




function App() {
  return (
    <div className="App" id="root">
      <div className="App-header">
        <h1>Hi Santhosh..!!</h1>
        <h3>Continue Tomorrow..</h3>
        <Link to='/header'> Header </Link>
        <Link to='/learning_20250522'> 22/05/2025 Learning</Link>
        <Link to='/learning_20250523'> 23/05/2025 Learning</Link>
         <Link to='/learning_20250524'> 24/05/2025 Learning</Link>
         
         <Link to='/learning_20250525'> 25/05/2025 Learning</Link>
         <Link to='/learning_20250526'> 26/05/2025 Learning</Link>
         <Link to='/learning_20250527'> 27/05/2025 Learning</Link>
         <Link to='/learning_20250529'> 29/05/2025 Learning</Link>
          <Link to='/learning_20250530'> 30/05/2025 Learning</Link>

        <Link to='/test'> Test Route </Link> {/* Add a new test link */}
       
      </div>

    </div>
  );
}

export default App;